import axios from '@/utils/axios';

// 地址列表
export function GetAddressList(page, limit) {
    return axios({
        url: '/address/list',
        method: 'get',
        params: { page, limit },
    });
}
//地址详情
export function AddressInfo(addressId) {
    return axios({
        url: '/address',
        method: 'get',
        params: { addressId },
    });
}

//获取用户默认地址
export function AddressDefault() {
    return axios({
        url: '/address/default',
        method: 'get',
        params: { },
    });
}

// 添加地址
export function AddAddress(consignee, area, address,mobile, distributionCenterId, lat, lng, isDefault) {
    return axios({
        url: '/address/add',
        method: 'post',
        params: { consignee, area, address,mobile, distributionCenterId, lat, lng, isDefault },
    });
}

// 编辑地址
export function EditAddress( addressId, consignee, area, address, mobile, distributionCenterId, lat, lng, isDefault) {
    return axios({
        url: '/address/update',
        method: 'post',
        params: { addressId, consignee, area, address, mobile, distributionCenterId, lat, lng, isDefault },
    });
}

// 删除地址
export function DeleteAddress( addressId ) {
    return axios({
        url: '/address/delete',
        method: 'post',
        params: { addressId },
    });
}

// 设置默认地址
export function DefaultAddressUpdate( addressId ) {
    return axios({
        url: '/address/default/update',
        method: 'post',
        params: { addressId },
    });
}